import { render, staticRenderFns } from "./popUpAddGroup.vue?vue&type=template&id=085cc1e9&scoped=true"
import script from "./popUpAddGroup.vue?vue&type=script&lang=js"
export * from "./popUpAddGroup.vue?vue&type=script&lang=js"
import style0 from "./popUpAddGroup.vue?vue&type=style&index=0&id=085cc1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085cc1e9",
  null
  
)

export default component.exports